<template>
    <GlobalHeader></GlobalHeader>
    <NuxtPage></NuxtPage>
    <GlobalFooter></GlobalFooter>
    <VEditor />
</template>
<script lang="ts" setup></script>
